<h3 *ngIf="subtitle == typeIrops.CANCELED">{{ "srIrops.weTriedRearrangeYourItinerary" | translate }}</h3> <!-- srIropsCtrl.subtitulo == 1 -->
<h3 *ngIf="subtitle == typeIrops.DELAYED">{{ "srIrops.thanksFor" | translate }}</h3>